import type Task from '@/entities/task';
import type User from '@/entities/user';
import type {uuid} from '@/@types/schema';

type Filterable<T> = {filter: (predicate: (item: T) => boolean) => T[]};

/** The live tasks assigned to this user. A task can also be assigned to a group. */
export const tasksAssignedToUser = (tasks: Filterable<Task>, userId: uuid): Task[] =>
    tasks.filter(t => t.assignedTo === userId && t.assignedToType === 'U' && t.status !== 'D');

/** The addresses other users hold. A suspended user keeps theirs; a deleted user gives it up. */
export const liveUserEmails = (users: Filterable<User>): string[] =>
    users.filter(u => u.status !== 'D').map(u => u.email);
